import React from 'react'
import LazyLoad from 'react-lazyload'
import { FormattedMessage } from 'react-intl'

import GymSearchMap from '@components/GymSearchMap'

import * as HomeStyle from '../../Home.style'
import { Title, GymsWrapper, MapWrapper } from './Gyms.style'

export default function Gyms() {
  return (
    <GymsWrapper>
      <HomeStyle.Container>
        <Title thin>
          <FormattedMessage
            id="smb_acquisition_home.gyms_search.title"
            values={{
              strong: (...chunks) => <strong>{chunks}</strong>,
            }}
          />
        </Title>
      </HomeStyle.Container>

      <LazyLoad>
        <MapWrapper>
          <GymSearchMap />
        </MapWrapper>
      </LazyLoad>
    </GymsWrapper>
  )
}
